// extracted by mini-css-extract-plugin
export default {"container":"iVEQ33","title":"LW9oVk","subtitle":"TXVMOc","subsubtitle":"Tr_5Qg"};